import type { BackendClient } from '../../client'
import type { BackendConfig } from '../../config'
import { createTransport } from './transport'
import { HttpAIService } from './ai.http'
import { HttpRagService } from './rag.http'
import { HttpPromptStore } from './prompts.http'
import { HttpSystemPromptStore } from './system-prompts.http'
import { HttpSpeechService } from './speech.http'
import { HttpSkillStore } from './skills.http'

export function createHttpBackend(config: BackendConfig): BackendClient {
  const t = createTransport(config)
  return {
    ai: new HttpAIService(t),
    rag: new HttpRagService(t),
    prompts: new HttpPromptStore(t),
    systemPrompts: new HttpSystemPromptStore(t),
    speech: new HttpSpeechService(t),
    skills: new HttpSkillStore(t),
  }
}
